"use client"

import { useState } from "react"
import Modal from "./Modal"
import "../styles/AboutDeveloper.css"
import "../styles/Hero.css"
import { saveInquiry } from "../api/inquiries"

export default function AboutDeveloper() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    consent: false,
  })
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target

    // For phone field: only allow digits and max 10 characters
    if (name === "phone") {
      if (/^\d{0,10}$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }))
      }
      return
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required"
    } else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can only contain letters and spaces"
    }

    // Phone validation
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required"
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit number"
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required"
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid Email address"
    }

    // Consent validation
    if (!formData.consent) {
      newErrors.consent = "Please accept the consent to proceed"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) return

    const now = new Date()
    const offsetMs = 5.5 * 60 * 60 * 1000 // IST = UTC + 5 hours 30 mins
    const istTime = new Date(now.getTime() + offsetMs)
    const inquiry_datetime = istTime.toISOString().replace("T", " ").split(".")[0]

    const payload = {
      inquiry_datetime,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
    }

    setLoading(true)
    try {
      await saveInquiry(payload)
      alert("Thank you for your interest! We will contact you soon.")
      setFormData({ name: "", phone: "", email: "", consent: false })
      setErrors({})
    } catch (err) {
      console.error(err)
      alert("Failed to submit inquiry. Please try again later.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <section id="about" className="about-developer">
        <h3 className="section-label">ABOUT US</h3>

        <p className="about-text">
          Ashtech Presidential Towers brings an exclusive residential project in Sector 12, Greater Noida West, offering premium 3 and 4 BHK luxury apartments that represent the best of modern living. Designed for families who value space, comfort, and style, this project combines elegant architecture with top-class amenities and a prime location.
        </p>
        <p className="about-text">
          Each home is built with careful attention to detail, featuring modern layouts, spacious balconies, and well-ventilated interiors that fill rooms with natural light. The apartments come with high-quality fittings and premium finishes, offering a perfect balance of comfort and elegance. The 3 BHK flats are ideal for small families looking for stylish and practical living spaces, while the 4 BHK apartments offer larger families the luxury of extra space and privacy.
        </p>

        <hr className="section-divider" />

        <div className="contact-section">
          <div className="contact-left">
            <h3>Get In Touch!</h3>
            <p>
              If You Have Any Questions Or Need Further Information, Please Don't Hesitate To Get In Touch With Us. We're
              Here To Help And Provide You With The Answers You Need.
            </p>
            <button className="hero-buttons1" onClick={() => setIsModalOpen(true)}>
              INTERESTED
            </button>
          </div>

          {/* Inquiry Form */}
          <div className="form-card1">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Enter Name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <p className="error-text">{errors.name}</p>}

              <input
                type="tel"
                name="phone"
                placeholder="Enter Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors.phone && <p className="error-text">{errors.phone}</p>}

              <input
                type="email"
                name="email"
                placeholder="Enter Email ID"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="error-text">{errors.email}</p>}

              <div className="consent-checkbox">
                <input
                  type="checkbox"
                  id="consent"
                  name="consent"
                  checked={formData.consent}
                  onChange={handleChange}
                />
                <label htmlFor="consent">
                  I authorize company representatives to Call, SMS, Email or WhatsApp me about its products and offers.
                  This consent overrides any registration for DNC/NDNC.
                </label>
              </div>
              {errors.consent && <p className="error-text">{errors.consent}</p>}

              <button type="submit" className="form-submit-btn" disabled={loading}>
                {loading ? "Submitting..." : "BOOK NOW"}
              </button>
            </form>
          </div>
        </div>

        <div className="disclaimer">
          <h4>Project Rera - Coming Soon</h4>
          <p>
            Please be advised that this website is not an official site and serves solely as an informational portal managed by a RERA authorized real estate agent. It does not constitute an offer or guarantee of any services. properties cannot be guaranteed. The images showcased on this website are for representational purposes only and may not accurately reflect the actual properties. We may share your data with Real Estate Regulatory Authority (RERA) registered Developers for further processing as necessary. Additionally, we may send updates and information to the mobile number or email address registered with us. All rights reserved. The content, design, and information on this website are protected by copyright and other intellectual property rights. Any unauthorized use or reproduction of the content may violate applicable laws. For accurate and up-to-date information regarding services, pricing, availability, and any other details, it is recommended to contact us directly through the provided contact information on this website. Thank you for visiting our website. Disclaimer & <a href="#privacy">Privacy Policy</a>
          </p>
        </div>
      </section>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}

// "use client"

// import { useState } from "react"
// import Modal from "./Modal"
// import "../styles/AboutDeveloper.css"
// import "../styles/Hero.css" 
// import { saveInquiry } from "../api/inquiries"

// export default function AboutDeveloper() {
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     consent: false,
//   })
//   const [loading, setLoading] = useState(false)
//   const [isModalOpen, setIsModalOpen] = useState(false)

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }))
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     const now = new Date()
//     const offsetMs = 5.5 * 60 * 60 * 1000 // IST = UTC + 5 hours 30 mins
//     const istTime = new Date(now.getTime() + offsetMs)
//     const inquiry_datetime = istTime.toISOString().replace("T", " ").split(".")[0]
//     // const inquiry_datetime = new Date().toISOString().replace("T", " ").split(".")[0]
//     const payload = {
//       inquiry_datetime,
//       name: formData.name,
//       email: formData.email,
//       phone: formData.phone,
//     }

//     setLoading(true)
//     try {
//       await saveInquiry(payload)
//       alert("Thank you for your interest! We will contact you soon.")
//       setFormData({ name: "", phone: "", email: "", consent: false })
//     } catch (err) {
//       console.error(err)
//       alert("Failed to submit inquiry. Please try again later.")
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <>
//       <section id="about" className="about-developer">
//         <h3 className="section-label">ABOUT US</h3>

//         <p className="about-text">
//           Ashtech Presidential Towers brings an exclusive residential project in Sector 12, Greater Noida West, offering premium 3 and 4 BHK luxury apartments that represent the best of modern living. Designed for families who value space, comfort, and style, this project combines elegant architecture with top-class amenities and a prime location.
//         </p>
//         <p className="about-text">
//           Each home is built with careful attention to detail, featuring modern layouts, spacious balconies, and well-ventilated interiors that fill rooms with natural light. The apartments come with high-quality fittings and premium finishes, offering a perfect balance of comfort and elegance. The 3 BHK flats are ideal for small families looking for stylish and practical living spaces, while the 4 BHK apartments offer larger families the luxury of extra space and privacy.
//         </p>
    
//     <hr className="section-divider" />
    
//         <div className="contact-section">
//           <div className="contact-left">
//             <h3>Get In Touch!</h3>
//             <p>
//               If You Have Any Questions Or Need Further Information, Please Don't Hesitate To Get In Touch With Us. We're
//               Here To Help And Provide You With The Answers You Need.
//             </p>
//             <button className="hero-buttons1" onClick={() => setIsModalOpen(true)}>
//               INTERESTED
//             </button>
//           </div>

//           {/* Replaced Inquiry Form with “Book a Site Visit” Form */}
//           <div className="form-card1">
//             <form onSubmit={handleSubmit}>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Enter Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//               <input
//                 type="tel"
//                 name="phone"
//                 placeholder="Enter Phone Number"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 required
//                 pattern="\d{10}" 
//                 title="Please enter a 10-digit mobile number"
//               />
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Enter Email ID"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//               <div className="consent-checkbox">
//                 <input
//                   type="checkbox"
//                   id="consent"
//                   name="consent"
//                   checked={formData.consent}
//                   onChange={handleChange}
//                   required
//                 />
//                 <label htmlFor="consent">
//                   I authorize company representatives to Call, SMS, Email or WhatsApp me about its products and offers.
//                   This consent overrides any registration for DNC/NDNC.
//                 </label>
//               </div>
//               <button type="submit" className="form-submit-btn" disabled={loading}>
//                 {loading ? "Submitting..." : "BOOK NOW"}
//               </button>
//             </form>
//           </div>
//         </div>

//         <div className="disclaimer">
//           <h4>Project Rera - Coming Soon</h4>
//           <p>
//             Please be advised that this website is not an official site and serves solely as an informational portal managed by a RERA authorized real estate agent. It does not constitute an offer or guarantee of any services. properties cannot be guaranteed. The images showcased on this website are for representational purposes only and may not accurately reflect the actual properties. We may share your data with Real Estate Regulatory Authority (RERA) registered Developers for further processing as necessary. Additionally, we may send updates and information to the mobile number or email address registered with us. All rights reserved. The content, design, and information on this website are protected by copyright and other intellectual property rights. Any unauthorized use or reproduction of the content may violate applicable laws. For accurate and up-to-date information regarding services, pricing, availability, and any other details, it is recommended to contact us directly through the provided contact information on this website. Thank you for visiting our website. Disclaimer & <a href="#privacy">Privacy Policy</a>
//           </p>
//         </div>
//       </section>

//       <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
//     </>
//   )
// }
